// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"283":"cfc8bc63","453":"94463556","517":"aacee423","724":"b9b00f6b"}[chunkId] + ".chunk.js";
};